import { FC, useMemo } from 'react';

import { useRouter } from 'next/router';

import { ISidebarItem } from '~/common/interfaces/i-sidebar-item';
import { GenericMenuItem } from '~/common/components/GenericMenuItem';

interface ISidebarNavProps {
  nav: Omit<ISidebarItem, 'children'>;
  index: number;
}
export const SidebarNav: FC<ISidebarNavProps> = ({ nav, index }) => {
  const router = useRouter();

  const selected = useMemo(() => {
    if (!router || !router.asPath) {
      return false;
    }

    const currentPath =
      router.asPath.split(/[?#]/)[0].replace(/\/+$/, '') || '/';
    const itemPath = (nav.href || `/${nav.key}`).replace(/\/+$/, '') || '/';

    return currentPath === itemPath || currentPath.startsWith(`${itemPath}/`);
  }, [router, nav.href, nav.key]);

  return (
    <GenericMenuItem
      id={nav.key}
      icon={nav.icon}
      title={nav.label}
      index={index}
      key={String(index)}
      iconHoverColor="primary"
      currentColor="primary"
      currentIconColor="primary"
      hoverColor="primary"
      currentOpacity={0.25}
      hoverColorOpacity={0.25}
      selected={selected}
      href={nav.href || `/${nav.key}`}
    />
  );
};
